module.exports = __webpack_public_path__ + "img/redlock-ssl-30days-satisfaction.37428cf8.jpg";